import { render } from "./DesignerBar.vue?vue&type=template&id=7e20958b&scoped=true"
import script from "./DesignerBar.vue?vue&type=script&lang=js"
export * from "./DesignerBar.vue?vue&type=script&lang=js"

import "./DesignerBar.vue?vue&type=style&index=0&id=7e20958b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e20958b"

export default script